import Axios from 'axios';
import { IS_SACHSO } from 'constants/settings';
import { generateSHA1 } from 'helpers/CryptoHelper';
import { queryFirst } from 'helpers/QueryHelper';
import { sachsoClient } from '../configs/api';

function register(user: any) {
  return new Promise((resolve, reject) => {
    sachsoClient
      .post('/user/register', user)
      .then((response) => {
        resolve(response.data);
      })
      .catch((error) => {
        reject(error);
      });
  });
}

function getById(id: number) {
  return new Promise((resolve, reject) => {
    sachsoClient
      .get(`/user/${id}`)
      .then((response) => {
        resolve(response.data);
      })
      .catch((error) => {
        reject(error);
      });
  });
}

function updatePassword({ email, password }: { email: string; password: string }) {
  return new Promise((resolve, reject) => {
    queryFirst('p_SACHSO_USERS_ChangePassword', {
      Email: email,
      Password: generateSHA1(password),
    })
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
}

function updatePassword_hanhtrangso({ id, password }: { id: number; password: string }) {
  return new Promise((resolve, reject) => {
    const encryptNewPassword = generateSHA1(password).toString();
    if (IS_SACHSO) {
      Axios.post('https://cloud.softech.cloud/mobile/SGK/api/ChangePassword', {
        userId: id,
        NewPassword: encryptNewPassword,
      })
        .then((response) => {
          if (response.data.message === 'OK') {
            resolve(response.data);
          }
          if (response.data.message === 'ERROR') {
            reject(response.data);
          }
        })
        .catch((error) => {
          reject(error);
        });
    } else {
      resolve('Chỉ gọi API khi ở bản LIVE');
    }
  });
}

export { getById, register, updatePassword, updatePassword_hanhtrangso };
